import React, { Component } from "react";
export default class Recipe extends Component {
  componentWillUnmount() {
      this.props.resetStore();
  }

  componentWillMount() {
      if (this.props.match.params.id) {
          this.props.getOpticsOrder(this.props.match.params.id);
      }      
  }
  
  render(){    
    const handlePrint = () => {      
      window.print();      
      window.close();
    };

    //console.log("PROPS ORDEN DE ÓPTICA .::: ", this.props);
    const { optics_order } = this.props;
    const signature = optics_order ? optics_order.doctor_signature : null;
    
    const fechaFormateada = new Date().toLocaleDateString('es-ES', { day: '2-digit', month: '2-digit', year: 'numeric'}).replace(/\//g, '-');
    
    return(
      <React.Fragment>        
        <div
            className="dont-print"
            style={{
                display: "flex",
                justifyContent: "right",
                margin: "20px 20px 20px 0px",
            }}
        >
            <button
                className="btn btn-primary ml-3 mr-3"
                style={{
                    maxWidth: "100px",
                }}
                //onClick={() => print()}
                onClick={handlePrint}
            >
                IMPRIMIR
            </button>
        </div>
        <div          
          style={{
              position: "relative",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              color: "black"
          }}
        >
          <div            
            style={{
                //width: "800px",
                width: "700px",
                //height: "100%",
                height: "820px",
                backgroundColor: "white",
                paddingInline: '24px',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'space-between'
            }}
          >
            <div>
            <div className="d-flex justify-center mt-5 mb-2">
              <img
                  style={{ margin: '0 auto' }}
                  src={require("../../../../../assets/img/logo_prolaser_gris.png")}
                  alt="Prolaser_logo"
                  className="logo-transcription"
              />
            </div> 
            <div 
              className="mt-2 mb-2"
              style={{ borderTop: 'solid 3px red', width: '90%', margin: '0 auto', background: 'white' }}
            ></div>
            
              <div className="d-flex flex-row align-bottom mt-3">
                <strong style={{ textTransform: 'capitalize' }}>Paciente:</strong>
                <div className="d-flex w-100" style={{ borderBottom: 'solid 1px black', textTransform: 'capitalize' }}>
                  &nbsp;&nbsp;{this.props.match.params.patient && this.props.match.params.patient}
                </div>
              </div>

              <div className="d-flex flex-row align-bottom">
                <strong style={{ textTransform: 'capitalize' }}>Fecha:</strong>
                <div className="d-flex w-100" style={{ borderBottom: 'solid 1px black', textTransform: 'capitalize'}}>
                  &nbsp;&nbsp; { fechaFormateada }
                </div>
              </div>
              <p style={{ textAlign: 'center', marginTop: '8px' }}>
                <strong style={{ fontSize: '18px', textTransform: 'lowercase', fontStyle: 'italic' }}>
                  <span style={{ textTransform: 'capitalize' }}>Orden</span> de óptica
                </strong>
              </p>

              {this.props.optics_order && this.props.optics_order.comment &&
                  <div style={{ marginBottom: '12px' }}>
                    <span style={{ textTransform: 'capitalize', fontWeight: 700, fontSize: '14px'}}>Comentario:&nbsp;</span>                    
                    <span style={{ textTransform: 'lowercase' }}>{this.props.optics_order.comment}</span>                    
                  </div>
              }

              {this.props.optics_order &&
                <div>
                  <table className="table table-sm">
                    <thead>
                      <tr>
                        <th></th>
                        <th></th>
                        <th style={{ color: '#000', fontSize: '10px' }}>ESFERA</th>
                        <th style={{ color: '#000', fontSize: '10px' }}>CILINDRO</th>
                        <th style={{ color: '#000', fontSize: '10px' }}>EJE</th>
                        <th style={{ color: '#000', fontSize: '10px' }}>PRISMA</th>
                        <th style={{ color: '#000', fontSize: '10px' }}>BASE</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <th rowSpan={2} style={{ fontSize: '10px' }}>FINAL</th>
                        <th style={{ fontSize: '10px' }}>OD</th>
                        <td style={{ fontSize: '10px' }}>{this.props.optics_order.od_final_esfera}</td>
                        <td style={{ fontSize: '10px' }}>{this.props.optics_order.od_final_cilindro}</td>
                        <td style={{ fontSize: '10px' }}>{this.props.optics_order.od_final_eje}</td>
                        <td style={{ fontSize: '10px' }}>{this.props.optics_order.od_final_prisma}</td>
                        <td style={{ fontSize: '10px' }}>{this.props.optics_order.od_final_base}</td>
                      </tr>
                      <tr>                                             
                        <th style={{ fontSize: '10px' }}>OS</th>
                        <td style={{ fontSize: '10px' }}>{this.props.optics_order.os_final_esfera}</td>
                        <td style={{ fontSize: '10px' }}>{this.props.optics_order.os_final_cilindro}</td>
                        <td style={{ fontSize: '10px' }}>{this.props.optics_order.os_final_eje}</td>
                        <td style={{ fontSize: '10px' }}>{this.props.optics_order.os_final_prisma}</td>
                        <td style={{ fontSize: '10px' }}>{this.props.optics_order.os_final_base}</td>                        
                      </tr>
                      <tr>
                        <th rowSpan={2} style={{ fontSize: '10px' }}>ADICIÓN</th>
                        <th style={{ fontSize: '10px' }}>OD</th>
                        <td style={{ fontSize: '10px' }}>{this.props.optics_order.od_adicion_esfera}</td>
                        <td style={{ fontSize: '10px' }}>{this.props.optics_order.od_adicion_cilindro}</td>
                        <td style={{ fontSize: '10px' }}>{this.props.optics_order.od_adicion_eje}</td>
                        <td style={{ fontSize: '10px' }}>{this.props.optics_order.od_adicion_prisma}</td>
                        <td style={{ fontSize: '10px' }}>{this.props.optics_order.od_adicion_base}</td>                        
                      </tr>
                      <tr>                                          
                        <th style={{ fontSize: '10px' }}>OS</th>
                        <td style={{ fontSize: '10px' }}>{this.props.optics_order.os_adicion_esfera}</td>
                        <td style={{ fontSize: '10px' }}>{this.props.optics_order.os_adicion_cilindro}</td>
                        <td style={{ fontSize: '10px' }}>{this.props.optics_order.os_adicion_eje}</td>
                        <td style={{ fontSize: '10px' }}>{this.props.optics_order.os_adicion_prisma}</td>
                        <td style={{ fontSize: '10px' }}>{this.props.optics_order.os_adicion_base}</td>                        
                      </tr>                                      
                    </tbody>
                  </table>

                  {this.props.optics_order.dip &&
                    <div className="w-full" style={{ marginBottom: '8px' }}>
                      <span style={{ fontSize: '12px', color: '#000', fontWeight: 700 }}>Autorefractómetro</span>
                      <div className="d-flex flex-row" style={{ width: 200, justifyContent: 'space-between' }}>
                        <span style={{ fontWeight: 700, fontSize: '12px' }}>DIP</span>
                        <span>{this.props.optics_order.dip}</span>
                      </div>
                    </div>
                  }

                  <div style={{ display: 'flex', flexDirection: 'row', width: '100%', fontSize: '12px', textTransform: 'capitalize' }}>
                    <div style={{ display: 'flex', flexDirection: 'column', width: '50%' }}>
                      <label style={{ fontSize: '12px', color: '#000' }}>Tipo de lente</label>
                      <ul>
                        <li 
                          style={{ display: 'flex', flexDirection: 'row', width: '135px', justifyContent: 'space-between' }}
                        ><span style={{ fontWeight: 700 }}>Monofocal</span> {this.props.optics_order.monofocal == 'si' ? '✔️' : '🔲'}</li>
                        <li
                          style={{ display: 'flex', flexDirection: 'row', width: '135px', justifyContent: 'space-between' }}
                        ><span style={{ fontWeight: 700 }}>Progresivo</span> {this.props.optics_order.progresive == 'si' ? '✔️' : '🔲'}</li>
                        <li
                          style={{ display: 'flex', flexDirection: 'row', width: '135px', justifyContent: 'space-between' }}
                        ><span style={{ fontWeight: 700 }}>Bifocal</span> {this.props.optics_order.bifocal == 'si' ? '✔️' : '🔲'}</li>
                        <li
                          style={{ display: 'flex', flexDirection: 'row', width: '135px', justifyContent: 'space-between' }}
                        ><span style={{ fontWeight: 700 }}>Otro</span> {this.props.optics_order.type_other == 'si' ? '✔️' : '🔲'}</li>
                      </ul>
                    </div>

                    <div style={{ display: 'flex', flexDirection: 'column', width: '50%' }}>
                      <label style={{ fontSize: '12px', color: '#000' }}>Recomendación</label>
                      <ul>
                        <li 
                          style={{ display: 'flex', flexDirection: 'row', width: '175px', justifyContent: 'space-between' }}
                        ><span style={{ fontWeight: 700 }}>Filtro de luz azul</span> {this.props.optics_order.blue_filter == 'si' ? '✔️' : '🔲'}</li>
                        <li
                          style={{ display: 'flex', flexDirection: 'row', width: '175px', justifyContent: 'space-between' }}
                        ><span style={{ fontWeight: 700 }}>Antireflejo</span> {this.props.optics_order.anti_glare == 'si' ? '✔️' : '🔲'}</li>
                        <li
                          style={{ display: 'flex', flexDirection: 'row', width: '175px', justifyContent: 'space-between' }}
                        ><span style={{ fontWeight: 700 }}>Polarizado</span> {this.props.optics_order.polarized}</li>
                        <li
                          style={{ display: 'flex', flexDirection: 'row', width: '175px', justifyContent: 'space-between' }}
                        ><span style={{ fontWeight: 700 }}>Policarbonato</span> {this.props.optics_order.polycarbonate == 'si' ? '✔️' : '🔲'}</li>
                        <li
                          style={{ display: 'flex', flexDirection: 'row', width: '175px', justifyContent: 'space-between' }}
                        ><span style={{ fontWeight: 700 }}>Lentes de sol</span> {this.props.optics_order.polycarbonate == 'si' ? '✔️' : '🔲'}</li>
                        <li
                          style={{ display: 'flex', flexDirection: 'row', width: '175px', justifyContent: 'space-between' }}
                        ><span style={{ fontWeight: 700 }}>Teñido</span> {this.props.optics_order.had}</li>
                        <li
                          style={{ display: 'flex', flexDirection: 'row', width: '175px', justifyContent: 'space-between' }}
                        ><span style={{ fontWeight: 700 }}>Transitions</span> {this.props.optics_order.transitions}</li>
                        <li
                          style={{ display: 'flex', flexDirection: 'row', width: '175px', justifyContent: 'space-between' }}
                        ><span style={{ fontWeight: 700 }}>Otros</span> {this.props.optics_order.recomendation_other}</li>                        
                      </ul>                      
                    </div>
                  </div>

                  <div style={{ display: 'flex', flexDirection: 'row', gap: '12px' }}>
                    <table className="table table-sm table-bordered">
                      <thead>
                        <tr>
                          <th style={{ fontSize: '10px', color: '#000', textAlign: 'center' }} colSpan={3} >Final en lente de contacto {`${this.props.optics_order.contact_lens_type == 1 ? 'Escleral' : 'Rígido'}`}</th>
                        </tr>                        
                        <tr>
                          <th></th>
                          <th style={{ color: '#000', fontSize: '10px' }}>OD</th>
                          <th style={{ color: '#000', fontSize: '10px' }}>OS</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <th style={{ fontSize: '10px' }}>PWR.</th>
                          <td style={{ fontSize: '10px' }}>{this.props.optics_order.od_pwr && `${this.props.optics_order.od_pwr}`}</td>
                          <td style={{ fontSize: '10px' }}>{this.props.optics_order.os_pwr && `${this.props.optics_order.os_pwr}`}</td>
                        </tr>
                        <tr>
                          <th style={{ fontSize: '10px' }}>CYL</th>
                          <td style={{ fontSize: '10px' }}>{this.props.optics_order.od_cyl && `${this.props.optics_order.od_cyl}`}</td>
                          <td style={{ fontSize: '10px' }}>{this.props.optics_order.os_cyl && `${this.props.optics_order.os_cyl}`}</td>
                        </tr>
                        <tr>
                          <th style={{ fontSize: '10px' }}>EJE</th>
                          <td style={{ fontSize: '10px' }}>{this.props.optics_order.od_eje && `${this.props.optics_order.od_eje}`}</td>
                          <td style={{ fontSize: '10px' }}>{this.props.optics_order.os_eje && `${this.props.optics_order.os_eje}`}</td>
                        </tr>
                        <tr>
                          <th style={{ fontSize: '10px' }}>B.C.</th>
                          <td style={{ fontSize: '10px' }}>{this.props.optics_order.od_bc && `${this.props.optics_order.od_bc}`}</td>
                          <td style={{ fontSize: '10px' }}>{this.props.optics_order.os_bc && `${this.props.optics_order.os_bc}`}</td>
                        </tr>
                        <tr>
                          <th style={{ fontSize: '10px' }}>DIA</th>
                          <td style={{ fontSize: '10px' }}>{this.props.optics_order.od_dia && `${this.props.optics_order.od_dia}`}</td>
                          <td style={{ fontSize: '10px' }}>{this.props.optics_order.os_dia && `${this.props.optics_order.os_dia}`}</td>
                        </tr>
                        <tr>
                          <th style={{ fontSize: '10px' }}>ADD</th>
                          <td style={{ fontSize: '10px' }}>{this.props.optics_order.od_add && `${this.props.optics_order.od_add}`}</td>
                          <td style={{ fontSize: '10px' }}>{this.props.optics_order.os_add && `${this.props.optics_order.os_add}`}</td>
                        </tr>
                        <tr>
                          <th style={{ fontSize: '10px' }}>MARCA</th>
                          <td style={{ fontSize: '10px' }}>{this.props.optics_order.od_marca && `${this.props.optics_order.od_marca}`}</td>
                          <td style={{ fontSize: '10px' }}>{this.props.optics_order.os_marca && `${this.props.optics_order.os_marca}`}</td>
                        </tr>
                        <tr>
                          <th style={{ fontSize: '10px' }}>OTRO</th>
                          <td style={{ fontSize: '10px' }}>{this.props.optics_order.od_otro && `${this.props.optics_order.od_otro}`}</td>
                          <td style={{ fontSize: '10px' }}>{this.props.optics_order.os_otro && `${this.props.optics_order.os_otro}`}</td>
                        </tr>                                                                  
                      </tbody>
                    </table>
                  
                    <table className="table table-sm table-bordered">
                      <thead>
                        <tr>
                          <th style={{ fontSize: '10px', color: '#000', textAlign: 'center' }} colSpan={3} >Final en lente de contacto blando</th>
                        </tr>
                        <tr>
                          <th style={{ fontSize: '10px' }}></th>
                          <th style={{ color: '#000', fontSize: '10px' }}>OD</th>
                          <th style={{ color: '#000', fontSize: '10px' }}>OS</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <th style={{ fontSize: '10px' }}>ESF</th>
                          <td style={{ fontSize: '10px' }}>{this.props.optics_order.od_esf_blan && `${this.props.optics_order.od_esf_blan}`}</td>
                          <td style={{ fontSize: '10px' }}>{this.props.optics_order.os_esf_blan && `${this.props.optics_order.os_esf_blan}`}</td>
                        </tr>
                        <tr>
                          <th style={{ fontSize: '10px' }}>CIL</th>
                          <td style={{ fontSize: '10px' }}>{this.props.optics_order.od_cil_blan && `${this.props.optics_order.od_cil_blan}`}</td>
                          <td style={{ fontSize: '10px' }}>{this.props.optics_order.os_cil_blan && `${this.props.optics_order.os_cil_blan}`}</td>
                        </tr>
                        <tr>
                          <th style={{ fontSize: '10px' }}>EJE</th>
                          <td style={{ fontSize: '10px' }}>{this.props.optics_order.od_eje_blan && `${this.props.optics_order.od_eje_blan}`}</td>
                          <td style={{ fontSize: '10px' }}>{this.props.optics_order.os_eje_blan && `${this.props.optics_order.os_eje_blan}`}</td>
                        </tr>
                        <tr>
                          <th style={{ fontSize: '10px' }}>MARCA</th>
                          <td style={{ fontSize: '10px' }}>{this.props.optics_order.od_marca_blan && `${this.props.optics_order.od_marca_blan}`}</td>
                          <td style={{ fontSize: '10px' }}>{this.props.optics_order.os_marca_blan && `${this.props.optics_order.os_marca_blan}`}</td>
                        </tr>
                        <tr>
                          <th style={{ fontSize: '10px' }}>OTRO</th>
                          <td style={{ fontSize: '10px' }}>{this.props.optics_order.od_otro_blan && `${this.props.optics_order.od_otro_blan}`}</td>
                          <td style={{ fontSize: '10px' }}>{this.props.optics_order.os_otro_blan && `${this.props.optics_order.os_otro_blan}`}</td>
                        </tr>                        
                      </tbody>
                    </table>
                  </div>

                  {this.props.optics_order.notes &&
                  <div style={{ marginBottom: '12px' }}>
                    <span style={{ textTransform: 'capitalize', fontWeight: 700, fontSize: '14px'}}>Notas:&nbsp;</span>                    
                    <span style={{ textTransform: 'lowercase' }}>{this.props.optics_order.notes}</span>                    
                  </div>
                  }
                </div>
              }
            </div>
            <div
              style={{
                display: 'flex',
                flexDirection: 'row',                
                alignItems: 'center',
                width: '100%',
                justifyContent: signature ? 'space-around' : 'center',
                background: 'white'
              }}            
            >
              <div
                  style={{
                    display: 'flex',
                    flexGrow: signature ? '1' : undefined,
                    flexDirection: 'column',
                    justifyContent: 'center',
                    alignItems: 'center',
                    fontSize: '12px',
                    position: 'relative'
                  }}
                >                
                  <span style={{ textTransform: 'capitalize' }}>5a. Calle 14-35, zona 3, Edificio Las Tapias, Oficina 107</span>
                  <span style={{ textTransform: 'lowercase' }}>Tels. 7736-8712 y 7767-6590 / e-mail: prolaserguatemala@gmail.com</span>
                  <span style={{ textTransform: 'capitalize' }}>WhatsApp 4220-3735</span>
                  <span style={{ textTransform: 'capitalize' }}>www.prolaserguatemala.com.gt</span>
                              
              </div>

                {signature &&
                  <div
                    style={{
                      display: 'flex',                
                      justifyContent: 'right',
                      alignItems: 'center',
                      fontSize: '12px',
                      filter: 'contrast(1.05) brightness(1.02)'
                    }}
                  >
                    {
                    <img 
                        src={typeof signature === 'string' ? signature : URL.createObjectURL(signature)} 
                        alt="Firma" 
                        style={{maxWidth: '200px', maxHeight: '100px', objectFit: 'contain'}}
                    />
                    }
                  </div>
                }              
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}